import { useEffect } from "react";

export default function ThankYou() {
   useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // or "smooth"
    });
  }, []);
  return (
    <main className="main">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12 ">
            <div className="thank-you-div">
              <div>
                <img src="assets/img/thank-you-v.jpeg" alt="img-fluid" />

                <h1  style={{
      fontSize: "40px",
      fontWeight: "700",
      marginBottom: "10px",
    }}>
                  Thank You!
                </h1>
                <p  style={{
      color: "#475569",
      fontSize: "14px",
      lineHeight: "1.5",
      marginBottom: "10px",
    }}>
                  Your form has been submitted successfully.
                </p>
                <p style={{
      marginTop: "6px",
      fontSize: "12px",
      color: "#64748b",
    }}>
                  We appreciate your time — we'll review and get back to you
                  soon.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}